module.exports = __webpack_public_path__ + "img/haftig-oldRally.798a2697.jpg";